import PropTypes from 'prop-types';
import React from 'react';

import Badge from '../../common/badge/Badge';
import Icon from '../../common/icon/Icon';


const Rating = props =>
  <Badge
    className={props.mini ? 'mini' : null}
    backgroundColor={props.backgroundColor}
    color={props.color}
    label={props.mini ? props.rating || 'None' : `${props.rating ? props.rating : 'No'} Rating`}
    leftIcon={!props.mini ? <Icon name="star" /> : null}
    rightIcon={props.mini ? <Icon name="star" /> : null}
  />;

Rating.propTypes = {
  mini: PropTypes.bool,
  rating: PropTypes.number,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
};

module.exports = Rating;



// WEBPACK FOOTER //
// ./app/components/derived/rating/Rating.jsx